<template>
  <div class="orders-container">
    <el-card class="filter-card">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单编号">
          <el-input v-model="filterForm.orderSn" placeholder="请输入订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="!isMerchantUser" label="商家名称">
          <el-select
            v-model="filterForm.merchantId"
            filterable
            clearable
            placeholder="请选择商家名称"
            style="width: 220px">
            <el-option
              v-for="item in merchantOptions"
              :key="item.id"
              :label="item.companyName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-select
            v-model="filterForm.customerId"
            filterable
            clearable
            placeholder="请选择客户名称"
            style="width: 220px">
            <el-option
              v-for="item in customerOptions"
              :key="item.id"
              :label="item.companyName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="currentOrderType === 'all'" label="订单状态">
          <el-select v-model="filterForm.orderStatus" placeholder="请选择订单状态" clearable style="width: 180px">
            <el-option label="全部" value=""></el-option>
            <el-option label="未邮寄" value="NOT_SHIPPED"></el-option>
            <el-option label="在途" value="IN_TRANSIT"></el-option>
            <el-option label="测试中" value="TESTING"></el-option>
            <el-option label="已测试" value="TESTED"></el-option>
            <el-option label="已完成" value="COMPLETED"></el-option>
            <el-option label="争议中" value="DISPUTE"></el-option>
            <el-option label="复测中" value="RETESTING"></el-option>
            <el-option label="未结算" value="UNSETTLED"></el-option>
            <el-option label="回寄" value="RETURN"></el-option>
            <el-option label="转寄" value="FORWARD"></el-option>
            <el-option label="已取消" value="CANCEL"></el-option>
            <el-option label="即将/已超期" value="EXPIRING"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filterForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div class="table-header">
        <div class="header-left">
          <span class="title">{{ pageTitle }}</span>
          <span class="count">共 {{ totalItems }} 条</span>
        </div>
        <div class="header-right">
          <el-button 
            v-if="currentOrderType === 'all' && isAdminUser" 
            type="success" 
            icon="el-icon-plus" 
            @click="createOrder">新建订单</el-button>
        </div>
      </div>
      
      <el-table
        :data="orderList"
        border
        v-loading="tableLoading"
        :row-class-name="getRowClassName"
        style="width: 100%">
        <el-table-column
          prop="orderSn"
          label="订单编号"
          width="200">
          <template slot-scope="scope">
            <div class="order-sn-cell">
              {{ scope.row.orderSn }}
              <template v-if="scope.row.isRetest === 1">
                <el-tag size="mini" type="warning" style="margin-left: 5px">复测</el-tag>
              </template>
              <template v-if="scope.row.isDispute === 1">
                <el-tag size="mini" type="danger" style="margin-left: 5px">争议</el-tag>
              </template>
              <template v-if="scope.row.isBackOrder === 1">
                <el-tag size="mini" type="info" style="margin-left: 5px">回寄</el-tag>
              </template>
              <template v-if="scope.row.isForward === 1">
                <el-tag size="mini" type="success" style="margin-left: 5px">转寄</el-tag>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          width="150">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商家名称"
          width="150">
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          width="150">
        </el-table-column>
        <el-table-column
          prop="testCount"
          label="样品数量"
          width="100">
        </el-table-column>
        <el-table-column
          prop="deviceName"
          label="测试仪器"
          width="150">
        </el-table-column>
        <el-table-column
          prop="actualPrice"
          label="订单金额"
          width="120">
          <template slot-scope="scope">
            {{ scope.row.actualPrice ? '¥' + scope.row.actualPrice.toFixed(2) : '¥0.00' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderStatusName"
          label="状态"
          width="120">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.orderStatus)">{{ getStatusText(scope.row.orderStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="disputeResult"
          label="处理结果"
          width="120"
          v-if="currentOrderType === 'dispute'">
          <template slot-scope="scope">
            <el-tag :type="getDisputeResultType(scope.row.disputeResult)">{{ getDisputeResultText(scope.row.disputeResult) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="expectedEndTime"
          label="预期完成时间"
          width="160">
        </el-table-column>
        <!-- 添加超期天数列，仅在即将超期页面显示 -->
        <el-table-column
          v-if="currentOrderType === 'expiring'"
          label="超期情况"
          width="120">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.isExpired === 1 ? 'danger' : (scope.row.isExpiring === 1 ? 'warning' : 'info')"
              size="mini">
              {{ getExpiringDays(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="280"
          align="center"
          :fixed="viewport.width < 1200 ? false : 'right'"
        >
          <template slot-scope="scope">
            <div class="operation-buttons">
              <!-- 未邮寄订单操作按钮 - 参考 NotShippedOrders.vue -->
              <template v-if="scope.row.orderStatus === 'NOT_SHIPPED' || currentOrderType === 'not-shipped'">
                <el-button v-if="!isMerchantUser" type="primary" size="mini" @click="handleEdit(scope.row)">编辑订单</el-button>
                <el-button v-if="isMerchantUser" type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
                <el-button v-if="!isMerchantUser" type="success" size="mini" @click="handleShip(scope.row)">邮寄样品</el-button>
                <el-button 
                    v-if="isAdminUser"
                    type="warning" 
                    size="mini" 
                    @click="handleEditPrice(scope.row)">修改价格</el-button>
                <el-button 
                    v-if="isAdminUser" 
                    type="danger" 
                    size="mini" 
                    @click="handleDeleteOrder(scope.row)">删除订单</el-button>
              </template>
              
              <!-- 在途订单操作按钮 - 参考 InTransitOrders.vue -->
              <template v-else-if="scope.row.orderStatus === 'IN_TRANSIT' || currentOrderType === 'in-transit'">
                <el-button size="mini" type="primary" @click="handleDetail(scope.row)">查看详情</el-button>
                <template v-if="scope.row.isBackOrder === 1">
                  <!-- 已经申请回寄，只显示查看详情按钮 -->
                </template>
                <template v-else-if="scope.row.isBackOrder === -1">
                  <el-button type="warning" size="mini" @click="handleReturnShip(scope.row)">回寄样品</el-button>
                </template>
                <template v-else>
                  <el-button type="success" size="mini" @click="handleStartTest(scope.row)">进行测试</el-button>
                  <el-button v-if="isAdminUser" type="warning" size="mini" @click="handleApplyReturn(scope.row)">申请回寄</el-button>
                  <!-- <el-button type="info" size="mini" @click="handleTransferShip(scope.row)">转寄样品</el-button> -->
                </template>
                <el-button 
                    v-if="isAdminUser"
                    type="warning" 
                    size="mini" 
                    @click="handleEditPrice(scope.row)">修改价格</el-button>
              </template>
              
              <!-- 测试中订单操作按钮 - 参考 TestingOrders.vue -->
              <template v-else-if="scope.row.orderStatus === 'TESTING' || currentOrderType === 'testing'">
                <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
                <el-button type="success" size="mini" @click="handleUploadResult(scope.row)">上传测试结果</el-button>
                <el-button 
                    v-if="isAdminUser"
                    type="warning" 
                    size="mini" 
                    @click="handleEditPrice(scope.row)">修改价格</el-button>
              </template>
              
              <!-- 已测试订单操作按钮 -->
              <template v-else-if="(scope.row.orderStatus === 'TESTED' || currentOrderType === 'tested')">
                <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
                <el-button v-if="isAdminUser && scope.row.isUploadReports !== 1" type="success" size="mini" @click="handleUploadOtherAttachments(scope.row)">上传其他附件</el-button>
                <template v-if="scope.row.isBackOrder === -1">
                  <el-button type="warning" size="mini" @click="handleReturnShip(scope.row)">回寄样品</el-button>
                </template>
                <template v-else-if="scope.row.isForward === -1 && isAdminUser">
                  <el-button type="info" size="mini" @click="handleTransferShip(scope.row)">转寄样品</el-button>
                </template>
                <template v-else>
                  <el-button 
                    v-if="!isMerchantUser && scope.row.isDispute !== 1 && scope.row.isRetest !== 1 && scope.row.isBackOrder !== 1 && scope.row.isBackOrder !== -1 && scope.row.isForward !== 1 && scope.row.isForward !== -1" 
                    type="danger" 
                    size="mini" 
                    @click="handleRetestDispute(scope.row)">提出争议/复测</el-button>
                  <el-button 
                    v-if="scope.row.isDispute === 1 && scope.row.isForward === 1 && isAdminUser" 
                    type="info" 
                    size="mini" 
                    @click="handleTransferShip(scope.row)">转寄样品</el-button>
                  <el-button 
                    v-if="scope.row.isRetest === 1 && scope.row.disputeResult === 'WAIT_DISPUTE' && (isAdminUser || isMerchantUser)"
                    type="success" 
                    size="mini" 
                    @click="handleProcessRetest(scope.row)">处理复测</el-button>
                  <el-button 
                    v-if="isAdminUser && !scope.row.isDispute && !scope.row.isRetest" 
                    type="success" 
                    size="mini" 
                    @click="handleToSettle(scope.row)">进入结算</el-button>
                  <el-button v-if="isAdminUser && scope.row.isForward !== 1 && scope.row.isForward !== -1 && scope.row.isBackOrder !== 1 && scope.row.isBackOrder !== -1" type="warning" size="mini" @click="handleApplyReturn(scope.row)">申请回寄</el-button>
                  <el-button v-if="isAdminUser && scope.row.isForward !== 1 && scope.row.isForward !== -1 && scope.row.isBackOrder !== 1 && scope.row.isBackOrder !== -1" type="info" size="mini" @click="handleApplyForward(scope.row)">申请转寄</el-button>
                  <el-button 
                    v-if="isAdminUser && scope.row.orderStatus !== 'UNSETTLED'" 
                    type="warning" 
                    size="mini" 
                    @click="handleEditPrice(scope.row)">修改价格</el-button>
                </template>
              </template>
              
              <!-- 已完成订单操作按钮 -->
              <template v-else-if="scope.row.orderStatus === 'COMPLETED' || currentOrderType === 'completed'">
                <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
              </template>
              
              <!-- 超期订单操作按钮 -->
              <template v-else-if="scope.row.orderStatus === 'EXPIRING' || currentOrderType === 'expiring'">
                <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
              </template>
              
              <!-- 争议订单操作按钮 -->
              <template v-else-if="scope.row.orderStatus === 'DISPUTE' || currentOrderType === 'dispute'">
                <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
                <el-button type="warning" size="mini" @click="handleResolveDispute(scope.row)" v-if="scope.row.orderStatus === 'DISPUTE'">解决争议</el-button>
                <el-button type="success" size="mini" @click="handleUploadResult(scope.row)" v-if="scope.row.orderStatus === 'RETESTING'">提交复测结果</el-button>
                <el-button 
                  type="success" 
                  size="mini" 
                  @click="handleProcessRetest(scope.row)" 
                  v-if="scope.row.isRetest === 1 && scope.row.disputeResult === 'WAIT_DISPUTE' && (isAdminUser || isMerchantUser)">处理复测</el-button>
              </template>

              <!-- 复测中订单操作按钮 -->
              <template v-else-if="scope.row.orderStatus === 'RETESTING'">
                <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
                <el-button type="success" size="mini" @click="handleUploadResult(scope.row)">提交复测结果</el-button>
              </template>
              
              <!-- 未结算订单操作按钮 -->
              <template v-else-if="scope.row.orderStatus === 'UNSETTLED' || currentOrderType === 'unsettled'">
                <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
                <el-button v-if="isAdminUser" type="success" size="mini" @click="handleSettle(scope.row)">手动结算</el-button>
              </template>
              
              <!-- 回寄/转寄订单操作按钮 -->
              <template v-else-if="scope.row.orderStatus === 'RETURN' || currentOrderType === 'return'">
                <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
                <el-button 
                  v-if="scope.row.isForwardEnd === -1 && isAdminUser" 
                  type="success" 
                  size="mini" 
                  @click="handleDispatchOrder(scope.row)">派单邮寄</el-button>
                <el-button 
                  v-if="scope.row.isForward === -1 && isAdminUser" 
                  type="info" 
                  size="mini" 
                  @click="handleTransferShip(scope.row)">转寄样品</el-button>
              </template>
              
              <!-- 其他状态或所有订单页面下的操作按钮 -->
              <template v-else>
                <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
                <el-button 
                  v-if="scope.row.isForwardEnd === -1 && isAdminUser" 
                  type="success" 
                  size="mini" 
                  @click="handleDispatchOrder(scope.row)">派单邮寄</el-button>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="pageSize"
          :total="totalItems"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'
import { getCurrentRole, getTokenByRole } from '@/utils/request'

export default {
  name: 'OrderList',
  data() {
    return {
      filterForm: {
        orderSn: '',
        merchantId: '',
        customerId: '',
        orderStatus: '',
        dateRange: []
      },
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      orderList: [],
      merchantOptions: [],
      customerOptions: [],
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight
      },
      // 订单类型与状态映射
      orderTypeStatusMap: {
        all: '', // 所有订单
        'not-shipped': 'NOT_SHIPPED', // 未邮寄订单
        'in-transit': 'IN_TRANSIT', // 在途订单
        testing: 'TESTING', // 测试中订单
        tested: 'TESTED', // 已测试订单
        completed: 'COMPLETED', // 已完成订单
        expiring: 'EXPIRING', // 即将超期订单
        dispute: 'DISPUTERETEST', // 争议/复测订单
        unsettled: 'UNSETTLED', // 未结算订单
        return: 'RETURN_FORWARD', // 回寄/转寄订单
        forward: 'FORWARD', // 转寄订单
        cancel: 'CANCEL', // 取消订单
        pending: 'TESTED' // 待处理订单
      },
      // 标题映射
      orderTypeTitleMap: {
        all: '订单列表',
        'not-shipped': '未邮寄订单列表',
        'in-transit': '在途订单列表',
        testing: '测试中订单列表',
        tested: '已测试订单列表',
        completed: '已完成订单列表',
        expiring: '即将/已超期订单列表',
        dispute: '争议/复测订单列表',
        unsettled: '未结算订单列表',
        return: '回寄/转寄订单列表',
        pending: '待处理订单列表'
      }
    }
  },
  computed: {
    // 根据路由获取当前订单类型
    currentOrderType() {
      const path = this.$route.path
      const orderType = path.split('/').pop() // 获取路径最后一段作为订单类型
      return orderType
    },
    // 获取当前订单状态
    currentOrderStatus() {
      return this.orderTypeStatusMap[this.currentOrderType] || ''
    },
    // 获取页面标题
    pageTitle() {
      return this.orderTypeTitleMap[this.currentOrderType] || '订单列表'
    },
    // 判断是否为管理员用户
    isAdminUser() {
      const userRole = getCurrentRole();
      const token = getTokenByRole();
      // 验证用户角色和令牌
      return userRole === 'admin' && !!token;
    },
    // 判断是否为商家用户
    isMerchantUser() {
      const userRole = getCurrentRole();
      return userRole === 'merchant';
    }
  },
  watch: {
    // 监听路由变化，重新获取数据
    '$route.path'() {
      this.resetFilter()
      this.fetchOrders()
    }
  },
  created() {
    this.fetchOrders()
    this.fetchMerchantList()
    this.fetchCustomerList()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.viewport.width = window.innerWidth
      this.viewport.height = window.innerHeight
    },
    // 获取商家列表
    async fetchMerchantList() {
      try {
        const res = await adminApi.getMerchantList()
        if (res && Array.isArray(res)) {
          this.merchantOptions = res
        } else {
          this.merchantOptions = []
        }
      } catch (error) {
        console.error('获取商家列表失败:', error)
        this.merchantOptions = []
      }
    },
    // 获取客户列表
    async fetchCustomerList() {
      try {
        const res = await adminApi.getCustomerList()
        if (res && Array.isArray(res)) {
          this.customerOptions = res
        } else {
          this.customerOptions = []
        }
      } catch (error) {
        console.error('获取客户列表失败:', error)
        this.customerOptions = []
      }
    },
    async fetchOrders() {
      this.tableLoading = true
      try {
        // 构建请求参数
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          orderSn: this.filterForm.orderSn || undefined,
          merchantId: this.filterForm.merchantId || undefined,
          customerId: this.filterForm.customerId || undefined
        }

        // 处理订单状态参数
        if (this.currentOrderType === 'all') {
          // 所有订单页面，使用筛选条件中选择的状态
          params.orderStatus = this.filterForm.orderStatus || undefined
        } else if (this.currentOrderType === 'dispute') {
          // 争议/复测订单页面，使用特定状态
          params.orderStatus = 'DISPUTE_RETEST'
        } else if (this.currentOrderType === 'pending') {
          // 待处理订单页面，使用特定状态和条件
          params.orderStatus = 'TESTED'
          params.isDispute = 1
          params.isSettle = -1
        } else {
          // 其他类型订单页面
          params.orderStatus = this.currentOrderStatus || undefined
        }
        
        // 添加日期范围参数
        if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
          params.startDate = this.filterForm.dateRange[0]
          params.endDate = this.filterForm.dateRange[1]
        }
        
        const response = await adminApi.getOrderListByPage(params)
        
        if (response && response.data && response.data.code === 200) {
          this.orderList = response.data.data || []
          this.totalItems = response.data.count || 0
          
          // 调试输出订单数据
          console.log('获取到的订单列表数据:', this.orderList)
          if (this.orderList.length > 0) {
            console.log('第一条订单数据:', this.orderList[0])
            console.log('是否包含isExpiring字段:', this.orderList[0].hasOwnProperty('isExpiring'))
            console.log('是否包含isExpired字段:', this.orderList[0].hasOwnProperty('isExpired'))
            console.log('isExpiring值:', this.orderList[0].isExpiring)
            console.log('isExpired值:', this.orderList[0].isExpired)
          }
        } else {
          this.orderList = []
          this.totalItems = 0
          this.$message.error(response.msg || '获取订单列表失败')
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.orderList = []
        this.totalItems = 0
        this.$message.error('获取订单列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleFilter() {
      this.currentPage = 1
      this.fetchOrders()
    },
    resetFilter() {
      this.filterForm = {
        orderSn: '',
        merchantId: '',
        customerId: '',
        orderStatus: '',
        dateRange: []
      }
      this.currentPage = 1
      this.pageSize = 10
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchOrders()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchOrders()
    },
    // 获取状态类型（用于标签颜色）
    getStatusType(status) {
      const statusMap = {
        NOT_SHIPPED: 'info',
        IN_TRANSIT: 'primary',
        TESTING: 'warning',
        TESTED: 'success',
        COMPLETED: 'success',
        DISPUTE: 'danger',
        UNSETTLED: 'warning',
        RETURN: 'info',
        FORWARD: 'info',
        CANCEL: 'danger',
        EXPIRING: 'danger',
        RETESTING: 'warning',
        RETESTED: 'success',
        DISPUTED: 'success',
      }
      return statusMap[status] || 'info'
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        NOT_SHIPPED: '未邮寄',
        IN_TRANSIT: '在途',
        TESTING: '测试中',
        TESTED: '已测试',
        COMPLETED: '已完成',
        DISPUTE: '争议中',
        DISPUTED: '已处理争议',
        RETESTING: '复测中',
        RETESTED: '已复测',
        UNSETTLED: '未结算',
        RETURN: '回寄',
        FORWARD: '转寄',
        CANCEL: '已取消',
      }
      return statusMap[status] || '未知状态'
    },
    // 获取处理结果类型（用于标签颜色）
    getDisputeResultType(result) {
      const resultTypeMap = {
        DISPUTING: 'warning',
        RETESTING: 'warning',
        REJECT: 'danger',
        PASS: 'success',
        FORWARD: 'info'
      }
      return resultTypeMap[result] || 'info'
    },
    // 获取处理结果文本
    getDisputeResultText(result) {
      const resultTextMap = {
        DISPUTING: '争议中',
        RETESTING: '复测中',
        REJECT: '已驳回',
        PASS: '已处理',
        FORWARD: '转寄商家'
      }
      return resultTextMap[result] || '待处理'
    },
    // 查看订单详情
    handleDetail(row) {
      try {
        // 根据用户角色决定跳转路径
        const userRole = localStorage.getItem('userRole');
        let basePath = '/admin';
        
        if (userRole === 'merchant') {
          basePath = '/merchant';
        } else if (userRole === 'customer') {
          basePath = '/customer';
        }
        
        console.log('订单详情跳转: ID=', row.id, '用户角色=', userRole, '路径=', `${basePath}/orders/detail/${row.id}`);
        
        // 使用对应角色的路径跳转
        this.$router.push(`${basePath}/orders/detail/${row.id}`);
      } catch (error) {
        console.error('跳转到订单详情页面失败:', error);
        this.$message.error('跳转失败: ' + error.message);
      }
    },
    // 查看订单详情 (兼容性方法，用于支持旧代码)
    viewOrderDetails(id) {
      try {
        // 根据用户角色决定跳转路径
        const userRole = localStorage.getItem('userRole');
        let basePath = '/admin';
        
        if (userRole === 'merchant') {
          basePath = '/merchant';
        } else if (userRole === 'customer') {
          basePath = '/customer';
        }
        
        console.log('订单详情跳转: ID=', id, '用户角色=', userRole, '路径=', `${basePath}/orders/detail/${id}`);
        
        // 使用对应角色的路径跳转
        this.$router.push(`${basePath}/orders/detail/${id}`);
      } catch (error) {
        console.error('跳转到订单详情页面失败:', error);
        this.$message.error('跳转失败: ' + error.message);
      }
    },
    // 编辑订单
    handleEdit(row) {
      this.$router.push(`/admin/orders/edit/${row.id}`)
    },
    // 创建订单
    createOrder() {
      this.$router.push('/admin/orders/create')
    },
    // 邮寄样品
    handleShip(row) {
      this.$router.push({
        path: `/admin/orders/management/${row.id}`,
        query: {
          step: 'NOT_SHIPPED',
          action: 'ship'
        }
      })
    },
    // 回寄样品
    handleReturnShip(row) {
      this.$router.push({
        path: `/admin/orders/management/${row.id}`,
        query: {
          step: 'RETURN',
          action: 'return'
        }
      })
    },
    // 转寄样品
    handleTransferShip(row) {
      // 如果订单状态为在途，则显示转寄表单
      if (row.orderStatus === 'IN_TRANSIT') {
        // 创建临时变量存储转寄说明
        let transferRemark = '';
        
        // 添加文本域样式
        this.addTransferTextareaStyles();
        
        this.$confirm('', '转寄样品', {
          confirmButtonText: '提交',
          cancelButtonText: '取消',
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          distinguishCancelAndClose: true,
          customClass: 'transfer-dialog',
          dangerouslyUseHTMLString: true,
          message: `
            <div class="transfer-form">
              <div class="form-item">
                <label>项目名称:</label>
                <span>${row.projectName || '暂无'}</span>
              </div>
              <div class="form-item">
                <label>订单编号:</label>
                <span>${row.orderSn || '暂无'}</span>
              </div>
              <div class="form-item">
                <label>仪器名称:</label>
                <span>${row.deviceName || '暂无'}</span>
              </div>
              <div class="form-item">
                <label>测试价格:</label>
                <span>¥${row.actualPrice ? row.actualPrice.toFixed(2) : '0.00'}</span>
              </div>
              <div class="form-item" style="align-items: center;">
                <label>转寄说明:<span style="color: #f56c6c; margin-left: 4px;">*</span></label>
                <div style="flex: 1; width: 100%;">
                  <textarea id="transferRemarkTextarea" 
                    placeholder="请输入转寄说明"
                    style="width: 100%; min-height: 150px; padding: 12px 15px; border: 1px solid #dcdfe6; border-radius: 4px; resize: vertical; font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif; font-size: 14px; line-height: 1.6; color: #303133; transition: all 0.3s ease; margin-top: 5px; box-sizing: border-box; background-color: #f8f9fb; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) inset;"
                  ></textarea>
                </div>
              </div>
            </div>
          `
        }).then(() => {
          // 提交前验证转寄说明是否已填写
          const transferRemarkValue = document.getElementById('transferRemarkTextarea')?.value || '';
          
          if (!transferRemarkValue.trim()) {
            this.$message.error('请填写转寄说明');
            return Promise.reject('转寄说明不能为空');
          }
          
          // 提交后调用原来的接口
          const params = {
            id: row.id,
            orderStatus: 'FORWARD',
            remarks: transferRemarkValue
          }
          adminApi.updateOrderStatus(params)
            .then(res => {
              if (res) {
                this.$message.success('转寄操作成功')
                this.fetchOrders()
              } else {
                this.$message.error(res.data?.msg || '操作失败')
              }
            })
            .catch(error => {
              console.error('更新订单状态失败:', error)
              this.$message.error('转寄操作失败')
            })
        }).catch(() => {
          this.$message.warning('已取消操作')
        })
      } else {
        // 其他状态跳转到转寄页面
        // 根据用户角色决定跳转路径
        const userRole = localStorage.getItem('userRole')
        const basePath = userRole === 'merchant' ? '/merchant' : '/admin'
        
        this.$router.push({
          path: `${basePath}/orders/management/${row.id}`,
          query: {
            step: 'FORWARD',
            action: 'forward'
          }
        })
      }
    },
    // 添加文本域样式
    addTransferTextareaStyles() {
      // 创建样式标签
      const style = document.createElement('style');
      style.type = 'text/css';
      style.id = 'transfer-textarea-styles';
      
      // 如果已经存在则移除
      const existingStyle = document.getElementById('transfer-textarea-styles');
      if (existingStyle) {
        existingStyle.remove();
      }
      
      // 添加样式内容
      style.innerHTML = `
        #transferRemarkTextarea:hover {
          border-color: #c0c4cc !important;
        }
        
        #transferRemarkTextarea:focus {
          outline: none !important;
          border-color: #409EFF !important;
          background-color: #fff !important;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2) !important;
        }
        
        #transferRemarkTextarea::placeholder {
          color: #C0C4CC;
          font-size: 14px;
        }
      `;
      
      // 添加到文档头部
      document.head.appendChild(style);
    },
    // 开始测试
    handleStartTest(row) {
      this.$confirm(`是否确认对订单 ${row.orderSn} 进行测试?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id,
          orderStatus: 'TESTING'
        }
        adminApi.updateOrderStatus(params)
          .then(res => {
            if (res) {
              this.$message.success('操作成功')
              
              // 根据用户角色决定跳转路径
              const userRole = localStorage.getItem('userRole')
              let basePath = '/admin'
              
              if (userRole === 'merchant') {
                basePath = '/merchant'
              } else if (userRole === 'customer') {
                basePath = '/customer'
              }
              
              // 跳转到对应角色的测试中订单页面
              this.$router.push(`${basePath}/orders/testing`)
            } else {
              this.$message.error(res.data.msg || '操作失败')
            }
          })
          .catch(error => {
            console.error('更新订单状态失败:', error)
            this.$message.error('操作失败')
          })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    // 上传测试结果（测试中订单）
    handleUploadResult(row) {
      // 根据订单状态判断是上传测试结果还是复测结果
      const isRetest = row.orderStatus === 'RETESTING' || row.disputeResult === 'RETESTING';
      
      console.log('上传结果方法被调用', row);
      console.log('订单ID:', row.id);
      console.log('是否为复测:', isRetest);
      
      try {
        // 通过localStorage获取用户角色，而不是通过URL路径
        const userRole = localStorage.getItem('userRole');
        console.log('用户角色:', userRole);
        
        // 根据用户角色决定路由跳转
        if (userRole === 'merchant') {
          console.log('检测到商家端用户，使用商家端路由');
          
          // 使用商家端带步骤条的订单管理页面
          this.$router.push({
            path: `/merchant/orders/management/${row.id}`,
            query: {
              step: isRetest ? 'UPLOAD_RETEST' : 'UPLOAD_RESULT',
              action: isRetest ? 'upload_retest' : 'upload'
            }
          });
          
          console.log('商家端路由跳转请求已发送');
          return;
        } else if (userRole === 'customer') {
          console.log('检测到客户端用户');
          // 客户端可能不需要上传测试结果功能
          this.$message.warning('客户端不支持上传测试结果功能');
          return;
        }
        
        // 默认为管理端用户
        console.log('检测到管理端用户，使用管理端路由');
        
        // 管理端使用带步骤条的订单管理页面
        this.$router.push({
          path: `/admin/orders/management/${row.id}`,
          query: {
            step: isRetest ? 'UPLOAD_RETEST' : 'UPLOAD_RESULT',
            action: isRetest ? 'upload_retest' : 'upload'
          }
        });
        
        console.log('管理端路由跳转请求已发送');
      } catch (error) {
        console.error('跳转过程中发生错误:', error);
        this.$message.error('跳转失败: ' + error.message);
      }
    },
    // 完成测试
    handleCompleteTest(row) {
      this.$confirm(`是否确认完成订单 ${row.orderSn} 的测试?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id,
          orderStatus: 'TESTED'
        }
        adminApi.updateOrderStatus(params)
          .then(res => {
            if (res.data && res.data.code === 200) {
              this.$message.success('操作成功')
              this.fetchOrders()
            } else {
              this.$message.error(res.data.msg || '操作失败')
            }
          })
          .catch(error => {
            console.error('更新订单状态失败:', error)
            this.$message.error('操作失败')
          })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    // 催促处理（超期订单）
    handleExpedite(row) {
      this.$message.info(`已对订单 ${row.orderSn} 发送催促处理通知`)
    },
    // 查看报告
    handleViewReport(row) {
      // 这里根据实际情况跳转到报告页面或者打开报告预览
      this.$message.info('查看报告功能待实现')
    },
    // 解决争议
    handleResolveDispute(row) {
      // 根据用户角色决定跳转路径
      const userRole = localStorage.getItem('userRole')
      let basePath = '/admin'
      
      if (userRole === 'merchant') {
        basePath = '/merchant'
      } else if (userRole === 'customer') {
        basePath = '/customer'
      }
      
      this.$router.push({
        path: `${basePath}/orders/management/${row.id}`,
        query: {
          step: 'RESOLVE_DISPUTE',
          action: 'resolve_dispute'
        }
      })
    },
    // 结算订单
    handleSettle(row) {
      this.$confirm(`是否确认手动结算订单 ${row.orderSn}？`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableLoading = true;
        // 调用updateOrderStatus接口
        const params = {
          id: row.id,
          orderStatus: 'COMPLETED'
        };
        
        adminApi.updateOrderStatus(params)
          .then(res => {
            if (res) {
              this.$message.success('订单结算成功');
              // 刷新订单列表
              this.fetchOrders();
            } else {
              this.$message.error((res && res.msg) || '订单结算失败');
            }
          })
          .catch(error => {
            console.error('订单结算失败:', error);
            this.$message.error('订单结算失败: ' + (error.message || '未知错误'));
          })
          .finally(() => {
            this.tableLoading = false;
          });
      }).catch(() => {
        this.$message.info('已取消手动结算');
      });
    },
    // 提出争议/复测
    handleRetestDispute(row) {
      this.$confirm('请选择申请类型', '提示', {
        confirmButtonText: '提出争议',
        cancelButtonText: '申请复测',
        type: 'warning',
        distinguishCancelAndClose: true,
        callback: (action) => {
          // 根据用户角色决定跳转路径
          const userRole = localStorage.getItem('userRole')
          let basePath = '/admin'
          
          if (userRole === 'merchant') {
            basePath = '/merchant'
          } else if (userRole === 'customer') {
            basePath = '/customer'
          }
          
          if (action === 'confirm') {
            // 提出争议 - 跳转到争议提交表单
            this.$router.push({
              path: `${basePath}/orders/management/${row.id}`,
              query: {
                step: 'SUBMIT_DISPUTE',
                action: 'dispute'
              }
            });
          } else if (action === 'cancel') {
            // 申请复测 - 跳转到复测上传页面
            this.$router.push({
              path: `${basePath}/orders/management/${row.id}`,
              query: {
                step: 'SUBMIT_RETEST',
                action: 'retest'
              }
            });
          }
        }
      })
    },
    // 派单邮寄
    handleDispatchOrder(row) {
      // 根据用户角色决定跳转路径
      const userRole = localStorage.getItem('userRole')
      let basePath = '/admin'
      
      if (userRole === 'merchant') {
        basePath = '/merchant'
      } else if (userRole === 'customer') {
        basePath = '/customer'
      }
      
      this.$router.push({
        path: `${basePath}/orders/management/${row.id}`,
        query: {
          step: 'FORWARD',
          action: 'forward'
        }
      })
    },
    // 处理复测
    handleProcessRetest(row) {
      // 根据用户角色决定跳转路径
      const userRole = localStorage.getItem('userRole')
      let basePath = '/admin'
      
      if (userRole === 'merchant') {
        basePath = '/merchant'
      } else if (userRole === 'customer') {
        basePath = '/customer'
      }
      
      // 检查订单ID是否存在
      if (!row || !row.id) {
        console.error('处理复测错误: 订单ID不存在', row);
        this.$message.error('订单ID不存在，无法处理复测');
        return;
      }
      
      console.log('处理复测请求: 订单ID =', row.id);
      
      // 直接跳转到对应的处理复测页面
      this.$router.push(`${basePath}/orders/process-retest/${row.id}`);
    },
    // 进入结算
    handleToSettle(row) {
      this.$confirm(`是否确认将订单 ${row.orderSn} 转入未结算状态?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id,
          orderStatus: 'UNSETTLED'
        }
        
        adminApi.updateOrderStatus(params)
          .then(res => {
            if (res) {
              this.$message.success('已成功转入结算状态')
              // 跳转到未结算订单页面
              this.$router.push('/admin/orders/unsettled')
            } else {
              this.$message.error(res.data?.msg || '操作失败')
            }
          })
          .catch(error => {
            console.error('更新订单状态失败:', error)
            this.$message.error('转入结算状态失败')
          })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    getRowClassName({ row }) {
      // 调试输出行数据
      console.log('处理行样式的订单数据:', row)
      console.log('isExpired值:', row.isExpired, '类型:', typeof row.isExpired)
      console.log('isExpiring值:', row.isExpiring, '类型:', typeof row.isExpiring)
      
      // 修改判断逻辑，同时兼容数字和字符串类型
      if (row.isExpired == 1) {
        console.log('应用已超期样式')
        return 'expired-row';
      } else if (row.isExpiring == 1) {
        console.log('应用即将超期样式')
        return 'expiring-row';
      }
      return '';
    },
    // 获取超期天数
    getExpiringDays(row) {
      const today = new Date();
      const endDate = new Date(row.expectedEndTime);
      
      if (row.isExpired === 1) {
        // 已超期：计算已超期天数
        const diffTime = Math.abs(today - endDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return `已超期 ${diffDays} 天`;
      } else if (row.isExpiring === 1) {
        // 即将超期：计算剩余天数
        const diffTime = endDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return `剩余 ${diffDays} 天`;
      }
      return '正常';
    },
    // 处理申请回寄
    handleApplyReturn(row) {
      // 直接跳转到回寄申请页面
      this.$router.push({
        path: `/admin/orders/return/${row.id}`
      });
    },
    // 处理申请转寄
    handleApplyForward(row) {
      // 直接跳转到转寄申请页面
      this.$router.push({
        path: `/admin/orders/forward/${row.id}`
      });
    },
    // 上传其他附件
    handleUploadOtherAttachments(row) {
      // 根据用户角色决定跳转路径
      const userRole = localStorage.getItem('userRole')
      let basePath = '/admin'
      
      if (userRole === 'merchant') {
        basePath = '/merchant'
      } else if (userRole === 'customer') {
        basePath = '/customer'
      }
      
      this.$router.push({
        path: `${basePath}/orders/management/${row.id}`,
        query: {
          step: 'UPLOAD_REPORTS',
          action: 'upload_reports'
        }
      })
    },
    // 修改价格
    handleEditPrice(row) {
      // 创建包含订单信息的富文本消息
      const messageHtml = `
        <div style="margin-bottom: 15px; line-height: 1.5;">
          <div style="margin-bottom: 8px;"><span style="font-weight: bold;">订单编号：</span>${row.orderSn}</div>
          <div><span style="font-weight: bold;">项目名称：</span>${row.projectName}</div>
        </div>
      `;
      
      this.$prompt('请输入新的订单价格', '修改价格', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]+(\.[0-9]{1,2})?$/,
        inputErrorMessage: '请输入有效的价格（数字，最多两位小数）',
        inputValue: row.actualPrice ? row.actualPrice.toString() : '0.00',
        dangerouslyUseHTMLString: true,
        message: messageHtml
      }).then(({ value }) => {
        // 价格转换为数字
        const newPrice = parseFloat(value);
        if (isNaN(newPrice) || newPrice < 0) {
          this.$message.error('请输入有效的价格');
          return;
        }
        
        // 调用API更新价格
        const params = {
          id: row.id,
          actualPrice: newPrice
        };
        
        this.tableLoading = true;
        adminApi.updateOrderPrice(params)
          .then(res => {
            if (res) {
              this.$message.success('价格修改成功');
              this.fetchOrders(); // 刷新订单列表
            } else {
              this.$message.error('价格修改失败');
            }
          })
          .catch(error => {
            console.error('价格修改失败:', error);
            this.$message.error('价格修改失败: ' + (error.message || '未知错误'));
          })
          .finally(() => {
            this.tableLoading = false;
          });
      }).catch(() => {
        this.$message.info('已取消修改价格');
      });
    },
    // 删除订单
    handleDeleteOrder(row) {
      this.$confirm(`确定要删除订单 ${row.orderSn} 吗？此操作不可恢复！`, '删除订单', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true,
        message: `
          <div style="margin-bottom: 15px; line-height: 1.5;">
            <div style="margin-bottom: 8px;"><span style="font-weight: bold;">订单编号：</span>${row.orderSn}</div>
            <div style="margin-bottom: 8px;"><span style="font-weight: bold;">项目名称：</span>${row.projectName}</div>
            <div><span style="font-weight: bold;">订单状态：</span>${this.getStatusText(row.orderStatus)}</div>
            <div style="color: #F56C6C; margin-top: 10px; font-weight: bold;">注意：只有未邮寄状态的订单才能删除！</div>
          </div>
        `
      }).then(() => {
        if (row.orderStatus !== 'NOT_SHIPPED') {
          this.$message.error('只能删除未邮寄状态的订单！');
          return;
        }
        
        this.tableLoading = true;
        
        
        adminApi.deleteOrder(row.id)
          .then(res => {
            if (res) {
              this.$message.success('订单删除成功');
              this.fetchOrders(); // 刷新订单列表
            } else {
              this.$message.error(res.data?.msg || '订单删除失败');
            }
          })
          .catch(error => {
            console.error('订单删除失败:', error);
            this.$message.error('订单删除失败: ' + (error.message || '未知错误'));
          })
          .finally(() => {
            this.tableLoading = false;
          });
      }).catch(() => {
        this.$message.info('已取消删除操作');
      });
    }
  }
}
</script>

<style>
.orders-container {
  padding: 20px;
}
.filter-card {
  margin-bottom: 20px;
}
.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
}

.filter-form .el-form-item {
  min-width: 240px;
  margin-bottom: 10px;
  margin-right: 0;
}

/* 创建时间选择器样式 */
.filter-form .el-date-editor {
  width: 360px !important;
}

/* 按钮组样式 */
.filter-form .el-form-item:last-child {
  min-width: 180px;
}

.table-card {
  margin-bottom: 20px;
}
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.header-left {
  display: flex;
  align-items: center;
}
.title {
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
}
.count {
  font-size: 14px;
  color: #666;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.operation-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
}

/* 操作按钮样式 */
.operation-buttons .el-button {
  margin: 3px;
  min-width: 90px;
}

/* 订单编号单元格样式 */
.order-sn-cell {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
}

/* 转寄表单样式 */
.transfer-dialog .el-message-box {
  width: 500px !important;
  max-width: 95vw;
  border-radius: 8px;
  overflow: hidden;
}

.transfer-dialog .el-message-box__header {
  padding: 15px 20px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  position: relative;
}

.transfer-dialog .el-message-box__title {
  font-size: 18px;
  color: #303133;
  font-weight: bold;
}

.transfer-dialog .el-message-box__headerbtn {
  top: 16px;
}

.transfer-dialog .el-message-box__content {
  padding: 20px;
}

.transfer-dialog .el-message-box__btns {
  padding: 10px 20px 15px;
  border-top: 1px solid #f0f0f0;
}

.transfer-dialog .el-message-box__btns button {
  min-width: 80px;
  padding: 8px 15px;
  font-size: 14px;
}

.transfer-dialog .el-button--primary {
  background-color: #409EFF;
  border-color: #409EFF;
}

.transfer-form {
  padding: 0;
}

.transfer-form .form-item {
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px dashed #ebeef5;
  padding-bottom: 12px;
}

.transfer-form .form-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.transfer-form .form-item label {
  width: 90px;
  text-align: right;
  padding-right: 15px;
  font-weight: bold;
  line-height: 32px;
  color: #606266;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.transfer-form .form-item span {
  flex: 1;
  line-height: 32px;
  color: #303133;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

/* 转寄说明输入框样式 */
.transfer-remark-textarea {
  width: 100%;
  min-height: 150px;
  padding: 12px 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  resize: vertical;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #303133;
  transition: all 0.3s ease;
  margin-top: 5px;
  box-sizing: border-box;
  background-color: #f8f9fb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) inset;
}

.transfer-remark-textarea:hover {
  border-color: #c0c4cc;
}

.transfer-remark-textarea:focus {
  outline: none;
  border-color: #409EFF;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.transfer-remark-textarea::placeholder {
  color: #C0C4CC;
  font-size: 14px;
}

/* 确保ID选择器的样式也被保留 */
#transferRemarkTextarea {
  width: 100%;
  min-height: 150px;
  padding: 12px 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  resize: vertical;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #303133;
  transition: all 0.3s ease;
  margin-top: 5px;
  box-sizing: border-box;
  background-color: #f8f9fb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) inset;
}

#transferRemarkTextarea:hover {
  border-color: #c0c4cc;
}

#transferRemarkTextarea:focus {
  outline: none;
  border-color: #409EFF;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

#transferRemarkTextarea::placeholder {
  color: #C0C4CC;
  font-size: 14px;
}

/* 适配移动仪器时的按钮样式 */
@media screen and (max-width: 768px) {
  .operation-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .operation-buttons .el-button {
    margin: 3px 0;
    width: 100%;
  }
}

/* 订单超期样式 */
.expired-row {
  color: #F56C6C !important;
}

.expired-row td {
  color: #F56C6C !important;
}

/* 订单即将超期样式 */
.expiring-row {
  color: #E6A23C !important;
}

.expiring-row td {
  color: #E6A23C !important;
}
</style> 